import { isEmpty } from 'lodash';
import generateFieldListToStub from './generateFieldListToStub';
import createStubbedFieldsData from './createStubbedFieldsData';

export default (nextType, question) => {
  const fieldListToStub = generateFieldListToStub(nextType);
  return isEmpty(fieldListToStub)
    ? question
    : {
        ...question,
        ...createStubbedFieldsData(question, nextType, fieldListToStub),
      };
};
